import { render, staticRenderFns } from "./ClientCategoriesSelect.vue?vue&type=template&id=41b8b6cb"
import script from "./ClientCategoriesSelect.vue?vue&type=script&lang=js"
export * from "./ClientCategoriesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports